export default {
    accountsettings: 'Settings',
    backend: 'Backend',
    administration: 'Administration',
    logout: 'Log out'
}
